// extracted by mini-css-extract-plugin
export default {"geofencing":"Geofencing__geofencing--2UV"};